import { render, staticRenderFns } from "./MyPageView.vue?vue&type=template&id=503638e1"
import script from "./MyPageView.ts?vue&type=script&lang=ts&external"
export * from "./MyPageView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports